import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './layouts/main/main.component';
import { authGuard } from './public/services/auth.guard';
import { portalAccessGuard } from './public/services/portal-access.guard';
import { paymentOfficerGuard } from './public/services/payment-officer.guard';
import { prMigrationOfficerGuard } from './public/services/pr-migration-officer.guard';
import { entitiesAccessGuard } from './public/services/entities-access.guard';

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [authGuard, portalAccessGuard],
    children: [
      {
        path: '',
        redirectTo: 'applications',
        pathMatch: 'full'
      },
      {
        path: 'applications',
        loadChildren: () => import('./features/application/application.module').then(m => m.ApplicationModule)
      },
      {
        path: 'entities',
        canActivate: [entitiesAccessGuard],
        loadChildren: () => import('./features/registered-entity/registered-entity.module').then(m => m.RegisteredEntityModule)
      },
      {
        path: 'payments',
        canActivate: [paymentOfficerGuard],
        loadChildren: () => import('./features/payments/payments.module').then(m => m.PaymentsModule)
      },
      {
        path: 'pr-migration',
        canActivate: [prMigrationOfficerGuard],
        loadChildren: () => import('./features/public-register-migration/public-register-migration.module').then(m => m.PublicRegisterMigrationModule)
      },
      {
        path: 'aml-reporting',
        loadChildren: () => import('./features/aml-reporting/aml-reporting.routes').then(m => m.AML_REPORTING_ROUTES)
      }
    ]
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./public/public.module').then((m) => m.PublicModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledNonBlocking' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
